<!-- zoom信息 -->
<template>
  <div class="zoom-detail">
    <div class="zoom-detail-container">
      <div class="zoom-detail-right">
        <div class="zoom-detail-info">
          <h1>
            <span v-if="isPackageId && (appDetail.module === 'MODULE_1')">PS Brainstorming</span>
            <span v-else> {{appDetail.module | moduleTitleMap}}</span>
           </h1>
          <ul>
            <li>
              <p v-if="!!appDetail.resultTime">Starting time：{{appDetail.mentorResultTimeStr}} ({{appDetail.mentorZone | zoneTitleMap}})</p>
              <div v-show="appDetail.predictTime">Expected discussion time：{{appDetail.predictTime}}mins</div>
              <p v-show="appDetail.title">Discussion topic：{{appDetail.title}}</p>
            </li>
            <li v-show="isShow"></li>
            <template v-if="isShow">
              <li v-for="(item, index) in trackInfo"
                  :key="index">
                <template v-if="item.resultTime">
                  <p>{{index+1}}. {{item.createRole === "MENTOR"? 'Mentor':'Mentee' }} confirmed time</p>
                  <div>{{item.resultTimeStr}}
                    <span>({{ item.mentorZone | zoneTitleMap}})</span>
                  </div>
                </template>
                <template v-else>
                  <p>{{index+1}}. {{item.createRole === "MENTOR"? 'Mentor':'Mentee' }}
                    proposed time <span>({{ item.mentorZone | zoneTitleMap}})</span>
                    <div v-for="(time, timeIndex) in item.content"
                         :key="timeIndex"> {{time.minTimeStr}} - {{time.maxTimeStr}}{{timeIndex===0?' (Most preferred)':''}}</div>
                </template>
              </li>
              <!-- <li>
                <p>2. CD withdrew time</p>
                <div>2019-03-22 16:00 (Eastern Standard Time)</div>
              </li> -->
            </template>
            <li :class="[isShow?'dis-64':'']">
              <span @click="isShow = !isShow"
                    class="show-detail">{{isShow?'Hide details':'Show details'}}</span>
            </li>
          </ul>
        </div>
        <!-- orange red green -->
        <!-- orange Please fill in the feedback -->
        <!-- green Appointment time has been confirmed -->
        <div class="zoom-detail-prompt"
             :class="appDetail.statu|todoStatusColorMap">
          <span>{{ appDetail.statu|todoStatusTitleMap }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// images
import logo from '@/assets/images/home/Chrome.svg'
// api
import { getAppTrackList } from '@/api/appointment'
export default {
  name: 'zoom-detail',
  props: ['appDetail', 'id', 'isPackageId'],
  components: {},
  data () {
    return {
      logo,
      isShow: false,
      trackInfo: []
    }
  },
  computed: {},
  mounted () {
    this.getAppTrackList()
  },
  methods: {
    getAppTrackList () {
      getAppTrackList({
        id: this.id
      }).then(res => {
        this.trackInfo = res.data.model
      })
    }
  }
}
</script>
<style lang='less' scoped>
</style>
